import React, { lazy, Suspense, useEffect, useContext, useState } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Loading from 'components/shared-components/Loading'
import PropTypes from 'prop-types'
import { fetchLicenseDetails } from '../../firebase/fireStore/licensingDbMethods'
import { AuthContext, SystemFlagContext, FeaturesContext } from 'auth/AuthProvider'
import {
  getTenantId,
  hasLgeServiceAccess,
  getUserPermission,
} from 'auth/FirebaseAuth'
import { Spin } from 'antd'
import { LicenseStateContext, DeviceUsersStateContext } from 'App'
import { zDNA_FEATURE } from '../../constants/Constant'
import { useDispatch, useSelector } from 'react-redux'
import { fetchDeviceCountsFromDB } from 'redux/actions/DeviceCounts'
import { getDeviceUsersStatus } from '../../firebase/fireStore/deviceUsersDBMethods'
import { GoogleDriveContext } from '../../auth/GoogleDriveProvider'
import { EHS } from 'constants/FeatureFlagConstant'
import { EHS_FEATURE_ENABLED} from 'constants/EnterpriseHomeScreenDesignerConstant'
import useMyFilesEnabled from 'hooks/useMyFilesEnabled' // EDCL-350 (RS)

export const AppViews = ({ match }) => {
  const context = useContext(AuthContext)
  const systemEnabled = useContext(SystemFlagContext)
  const featuresContext = useContext(FeaturesContext) // EDCL-33
  const isEHSFeatureEnabled = featuresContext?.[EHS] === EHS_FEATURE_ENABLED;
  const isMyFilesEnabled = useMyFilesEnabled() // EDCL-350 (RS)
  const user = context?.currentUser
  const tenantId = getTenantId(user)
  const gddata = React.useContext(GoogleDriveContext)
  const dispatch = useDispatch()
  const [enableAndroidUpdateTab] = useState(
    hasLgeServiceAccess(context?.currentUser) || gddata.enrollmentTokenAvailable
  )
  const { licenseState, setLicenseState, setIsLicenseAvailable } = useContext(LicenseStateContext)
  const { deviceUsersState, setDeviceUsersState } = useContext(DeviceUsersStateContext)
  const deviceCountsReducer = useSelector((state) => state.deviceCounts)
  const [pending, setPending] = useState(true)
  const [wiPermission] = useState(true) // Wireless Insights Code
  const userPermission = getUserPermission(context?.currentUser)
  const noAccessPermissions =
    userPermission && userPermission.permissions
      ? userPermission.permissions.filter((permission) =>
          permission.permissionString.includes('noaccess')
        )
      : []

  useEffect(() => {
    init()
    deviceUsersStateCheck()
  }, [])

  useEffect(() => {
    console.log('Permission Chnaged:', context?.currentUser)
    // setWiPermission(getWiPermission(context?.currentUser)) // This part is to controll the visibility of the WI item in the menu
  }, [context?.currentUser?.claims?.wiPermission])

  function init() {
    console.log('AppViews ' + JSON.stringify(context?.currentUser))
    dispatch(fetchDeviceCountsFromDB(tenantId))
    fetchLicenseDetails(tenantId)
      .then((res) => {
        if (res && res.status && res.status === 'false') {
          setLicenseState(false)
          setIsLicenseAvailable(false)
        }
        if (res[zDNA_FEATURE]) {
          setIsLicenseAvailable(true)
        } else {
          setIsLicenseAvailable(false)
        }

        if (res && res[zDNA_FEATURE]) {
          res[zDNA_FEATURE]?.usedCount && res[zDNA_FEATURE]?.usedCount > 0
            ? setLicenseState(true)
            : setLicenseState(false)
        } else {
          setLicenseState(false)
        }
        setPending(false)
      })
      .catch((err) => {
        console.log(err)
        setPending(false)
      })
  }

  function deviceUsersStateCheck() {
    getDeviceUsersStatus(tenantId, {})
      .then((flag) => {
        setDeviceUsersState(flag)
      })
      .catch((err) => {
        console.log(err)
        setDeviceUsersState(false)
      })
  }

  if (pending && deviceCountsReducer.loading) {
    return (
      <>
        <Spin size="large" tip="Loading" />
      </>
    )
  }

  let isAuthProcessCompleted =
    gddata.isConnectedToZebraServices &&
    gddata.isConnectedToZebraServices === 'connected' &&
    gddata.zebraServiceAccountEmail
      ? true
      : false
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('dashboard')
        ) ? (
          <Route path={`${match.url}/home`} component={lazy(() => import(`./home`))} />
        ) : null}
        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('myDevice')
        ) ? (
          <Route path={`${match.url}/myDevice`} component={lazy(() => import(`./myDevice`))} />
        ) : null}
        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('initialSetupNew')
        ) ? (
          <Route
            path={`${match.url}/initialSetupNew`}
            component={lazy(() => import(`./initial-setupNew/index`))}
          />
        ) : null}
        {isAuthProcessCompleted &&
        !noAccessPermissions.some((permission) =>
          permission.permissionString.includes('licensing')
        ) ? (
          <Route
            path={`${match.url}/licensing`}
            component={lazy(() => import(`./licensing/index`))}
          />
        ) : null}

        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('designStudio')
        ) ? (
          <Route
            exact
            path={`${match.url}/designStudio`}
            component={lazy(() => import(`./design-studio`))}
          />
        ) : null}
        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('designStudio')
        ) ? (
          <Route
            exact
            path={`${match.url}/enterpriseKeyboardBuilder`}
            component={lazy(() => import(`./enterpriseKeyboardBuilder/views/list/index`))}
          />
        ) : null}
        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('designStudio')
        ) ? (
          <Route
            path={`${match.url}/enterpriseKeyboardBuilder/editor`}
            component={lazy(() => import(`./enterpriseKeyboardBuilder/views/editor/index.jsx`))}
          />
        ) : null}
            {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('designStudio')
        ) && isEHSFeatureEnabled ? (
          <Route
            exact
            path={`${match.url}/EnterpriseHomeScreenDesigner`}
            component={lazy(() => import(`./enterprise-home-screen-builder/views/index.js`))}
          />
        ) : null}
        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('designStudio')
        ) && isEHSFeatureEnabled ? (
          <Route
            exact
            path={`${match.url}/EnterpriseHomeScreenDesigner/editor`}
            component={lazy(() => import(`./enterprise-home-screen-builder/views/ehs-editor-page/index.js`))}
          />
        ) : null}
        {/* {!noAccessPermissions.some(permission => permission.permissionString.includes('rxLogger')) ? (<Route
          path={`${match.url}/rxlogger`}
          component={lazy(() => import(`./RxLogger/views/index`))}
        />) : null} */}

        {/* <Route
          exact
          path={`${match.url}/rxlogger`}
          component={lazy(() => import(`./pocRxLogger/views/index`))}
        /> */}

        <Route path={`${match.url}/authCode`} component={lazy(() => import(`./authCode/index`))} />
        <Route
          path={`${match.url}/googleAuthSuccessCallback`}
          component={lazy(() => import(`./googleAuthCallback/success`))}
        />
        <Route
          path={`${match.url}/googleAuthFailCallback`}
          component={lazy(() => import(`./googleAuthCallback/fail`))}
        />

        {deviceUsersState &&
        !noAccessPermissions.some((permission) =>
          permission.permissionString.includes('deviceUsers')
        ) ? (
          <Route
            path={`${match.url}/deviceUsers/usersRequest`}
            component={lazy(() => import(`./deviceUsers/usersRequest/index`))}
          />
        ) : null}

        {deviceUsersState &&
        !noAccessPermissions.some((permission) =>
          permission.permissionString.includes('deviceUsers')
        ) ? (
          <Route
            path={`${match.url}/deviceUsers`}
            component={lazy(() => import(`./deviceUsers/index`))}
          />
        ) : null}

        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('myApps')
        ) ? (
          <Route path={`${match.url}/myApps`} component={lazy(() => import(`./myApps/index`))} />
        ) : null}

        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('schedule')
        ) ? (
          <Route
            path={`${match.url}/contentManagement/schedule`}
            component={lazy(() => import(`../cm-views/views/schedule/index`))}
          />
        ) : null}

        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('myContent')
        ) ? (
          <Route
            path={`${match.url}/contentManagement/myContent`}
            component={lazy(() => import(`../cm-views/views/myContent/index`))}
          />
        ) : null}

        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('myContent')
        ) ? (
          <Route
            path={`${match.url}/contentManagement/recycle`}
            component={lazy(() => import(`../cm-views/views/recycle/index`))}
          />
        ) : null}
        {/*Wireless Insights codes Starts */}
        {wiPermission &&
        !noAccessPermissions.some((permission) =>
          permission.permissionString.includes('wirelessInsight')
        ) ? (
          <Route
            path={`${match.url}/supportTools/wirelessInsights`}
            component={lazy(() => import(`../wi-views/index`))}
          />
        ) : null}
        {/* Ends */}

        {licenseState &&
        enableAndroidUpdateTab &&
        isAuthProcessCompleted &&
        !noAccessPermissions.some((permission) =>
          permission.permissionString.includes('androidUpdates')
        ) ? (
          <Route
            path={`${match.url}/androidUpdates`}
            component={lazy(() => import(`./android-updates/index`))}
          />
        ) : null}

        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('remoteRxLogger')
        ) ? (
          <Route
            path={`${match.url}/supportTools/remoteRxLogger`}
            component={lazy(() => import(`./RxLogger/views/index`))}
          />
        ) : null}
        {!noAccessPermissions.some((permission) =>
          permission.permissionString.includes('wirelessInsights')
        ) ? (
          <Route
            path={`${match.url}/supportTools/wirelessInsights`}
            component={lazy(() => import(`./support-tools/wirelessInsights/index`))}
          />
        ) : null}
        {systemEnabled === 1 &&
        !noAccessPermissions.some((permission) =>
          permission.permissionString.includes('profileDependency')
        ) ? (
          <Route
            path={`${match.url}/profileDeployments`}
            component={lazy(() => import(`./profile-dependency/index`))}
          />
        ) : null}

        {isMyFilesEnabled &&
          <Route
            path={`${match.url}/myFiles`}
            component={ lazy ( () => import(`./my-files/index`))}
          />
          // EDCL-350 (RS)
        } 

        {!deviceCountsReducer.hasNoZdmAsDo &&
        isAuthProcessCompleted &&
        isAuthProcessCompleted &&
        !noAccessPermissions.some((permission) =>
          permission.permissionString.includes('deviceSettings')
        ) ? (
          <>
            <Route
              path={`${match.url}/deviceSettings`}
              component={lazy(() => import(`./device-settings/index`))}
            />
          </>
        ) : null}
        {!pending && !deviceCountsReducer.loading && (
          <Redirect from={`${match.url}`} to={`${match.url}/home`} />
        )}    
      </Switch>
    </Suspense>
  )
}

AppViews.propTypes = {
  match: PropTypes.object.isRequired,
}

export default AppViews
